module.exports = __webpack_public_path__ + "img/27_75.fcdf7a07.png";